import * as Yup from 'yup'

export const normalizeIdentificationField = value => (value ?? '').replace (/\D/g, '')

/*
  44 dígitos é o código de barras, lido pela câmera. 47 é a linha digitável de boleto
  bancário e 48 a de convênio/arrecadação (água, luz, tributos), digitadas ou coladas.

  Os três são aceitos porque a conversão de 44 para 47/48 acontece na API, num lugar só —
  fazê-la aqui repetiria o módulo 10/11 da FEBRABAN em cada front.

  O dígito verificador não é conferido aqui de propósito: quem valida a linha digitável é a
  simulação na API, e repetir o módulo 10/11 no front criaria uma segunda fonte de verdade
  para divergir dela. A checagem de tamanho existe só para não gastar uma ida ao servidor
  com erro de digitação óbvio.
*/
const bankingBillPaymentValidator = Yup.object ().shape ({
  identificationField: Yup.string ()
    .required ('Insira a linha digitável do boleto')
    .test (
      'identification-field-length',
      'O código deve ter 44, 47 ou 48 dígitos',
      value => [44, 47, 48].includes (normalizeIdentificationField (value).length)
    ),

  description: Yup.string ()
    .max (120, 'A descrição deve ter no máximo 120 caracteres')
})

export default bankingBillPaymentValidator
